import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/core/naturalidades${queryUrl}`)
  },
  insertNewNaturalness(data) {
    return axios.post('/core/naturalidades', data)
  },
  editNaturalness(data) {
    return axios.put(`/core/naturalidades/${data.id}`, data)
  },
  deleteNaturalness(id) {
    return axios.delete(`/core/naturalidades/${id}`)
  },
}
